import React from 'react';
import MetricTrackingPage from './MetricTrackingPage';

export default function GestionBodyFat() {
  return <MetricTrackingPage type="bodyfat" title="Grasa corporal" description="Sigue el porcentaje de grasa corporal con registros fechados y fáciles de consultar." field="bodyFatPercentage" unit="%" inputLabel="Grasa corporal" />;
}
